import {useQuery} from '@tanstack/react-query';
import {usersApi} from '../api';
import {UserModel} from '../model';

interface State {
  user: UserModel | null;
  isLoading: boolean;
  error: ApiError | null;
}

export const useUser = (): State => {
  const {data, isLoading, error} = useQuery<UserModel, ApiError>({
    queryKey: ['user'],
    queryFn: () => usersApi.getUser(),
  });

  return {
    user: data || null,
    isLoading,
    error,
  };
};
